import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/tadeo.barrera/" className="home__social-icon" rel='noreferrer' target="_blank" >
            <i className="uil uil-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/adrián-tadeo-barrera-almanza" className="home__social-icon" target="_blank" rel='noreferrer'>
            <i className="uil uil-linkedin"></i>
        </a>
        <a href="https://github.com/WatchMakker" className="home__social-icon" target="_blank"  rel='noreferrer'>
            <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social